import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/ru'

import Antd from 'ant-design-vue'
import ruRU from 'ant-design-vue/es/locale/ru_RU'
import 'ant-design-vue/dist/reset.css'

dayjs.extend(updateLocale)
dayjs.locale('ru')
dayjs.updateLocale('ru', {
  weekStart: 1,
})

createApp(App).use(createPinia()).use(router).use(Antd, { locale: ruRU }).mount('#app')
